import React, { useEffect, useMemo, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import { useLocation, useNavigate } from "react-router-dom";
import SelectComponent from "../../../components/Tenant/SelectComponent/SelectComponent";
import CustomExport from "../../../components/CustomExport/CustomExport";
import {
    useDeleteRedemptionMutation,
    useFetchRedemptionHistoryCountForTDSMutation,
    useFetchRedemptionHistoryForTDSMutation,
} from "../../../features/tenant/redeemptionHistory/redemptionHistoryApi";
import { hasPermission } from "../../../utils/hasPermission";
import { getVendorName } from "../../../utils/getVendorName";
import { formatter } from "../../../utils/numberFormatter";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import { transformToJSON } from "../../../redeemRequestJsonToCsv";
import { TiTimes } from "react-icons/ti";
import { useGetExtraRedeemedGiftsStatusMutation, useGetRedeemedGiftsStatusQuery, useUpdateDeliveryDetailsGiftRedemptionMutation, useUpdateRedeemedGiftsStatusMutation } from "../../../features/tenant/redeemedGiftsStatus/redeemedGiftsStatusApi";
import toast from "react-hot-toast";
import { useUploadSingleFileMutation } from "../../../features/admin/imageUpload/imageUploadApi";
import DeliveryProgressBar from "../../../components/DeliveryProgress/DeliveryProgressBar";
import TenantSlugs from "../../../utils/TenantSlug";

const redemptionsType = {
    '1': "gift",
    '2': 'cashback',
    "3": 'coupon',
    '4': 'dream gift'
}


const approvalStatusTypes = {
    '1': { label: 'ACCEPTED', color: 'bg-green-600' },
    '2': { label: 'REJECTED', color: 'bg-red-600' },
    '3': { label: 'PENDING', color: 'bg-gray-500' }
};


const RedemptionsList = () => {
    const navigate = useNavigate();

    const vendorData = JSON.parse(sessionStorage.getItem("companyProfile"));
    const redemptionHierarchy = vendorData.redemption_hierarchy && vendorData.redemption_hierarchy.gift_mapped_users;

    // console.log("location at SMS template", location);
    const primaryColor = JSON.parse(sessionStorage.getItem("vendorTheme")).theme
        .color_shades;

    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationResetToggle, setPaginationResetToggle] = useState(false);
    const [csvData, setCsvData] = useState(null);

    const [showViewModal, setShowViewModal] = useState(false);
    const [viewModalData, setViewModalData] = useState(null)
    const [images, setImages] = useState()
    const [myList, setMyList] = useState([]);
    const [totalRows, setTotalRows] = useState(0);

    const [progressBtnToggle, setProgressBtnToggle] = useState(false);
    const [popUpBtnToggle, setPopUpBtnToggle] = useState(false);
    const [currentStatus, setCurrentStatus] = useState(0);
    const [selectStatus, setSelectStatus] = useState(1);
    const [currentRefNo, setCurrentRefNo] = useState("");
    const [currentUserType, setCurrentUserType] = useState(null);
    const [lastStatus, setLastStatus] = useState(null);
    const [extraStatus, setExtraStatus] = useState([]);
    const [currentGiftCategory, setCurrentGiftCategory] = useState(null);
    const [couponCode, setCouponCode] = useState("");

    const [updatedDeliveryPartner, setUpdatedDeliveryPartner] = useState("");
    const [updatedTrackingId, setUpdatedTrackingId] = useState("");
    const appUserTypes = JSON.parse(sessionStorage.getItem("appUserType")) || [];
    const [appUsers, setAppUsers] = useState(appUserTypes);
    const [allZones, setAllZones] = useState([]);

    const [userTypesArray, setUserTypesArray] = useState({
        name: "All",
        id: null,
    });

    const [redeemGiftStatusData, setredeemGiftStatusData] = useState([]);

    const [userTypeId, setUserTypeId] = useState(null);

    const isRejectEnabled = false;
        // JSON.parse(sessionStorage.getItem("vendorData")).tenant_id ==
        // TenantSlugs.modenik.toString();

    const [userZone, setUserZone] = useState({
        name: "All Zones",
        id: 0,
    });

    const initialRequest = {
        name: "",
        mobile: "",
        user_id: "",
        user_type_id: userTypeId,
        limit: 10,
        offset: 0,
        startDate: "",
        endDate: "",
        ref_no: ""
    };
    const [request, setRequest] = useState(initialRequest);
    const clearFilters = () => {
        setRequest(initialRequest);
        setUserZone({
            name: "All Zones",
            id: 0,
        });
        setUserTypesArray({
            name: "All",
            id: null,
        })
    };

    const {
        data: getRedeemedGiftsStatusData,
        error: getRedeemedGiftsStatusError,
    } = useGetRedeemedGiftsStatusQuery({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
    });


    const [
        fetchRedemptionHistory,
        { data: redemptionHistoryData, error: redemptionHistoryError },
    ] = useFetchRedemptionHistoryForTDSMutation();

    const [
        fetchRedemptionHistoryCsv,
        { data: redemptionHistoryCsvData, error: redemptionHistoryCsvError },
    ] = useFetchRedemptionHistoryForTDSMutation();
    const [
        fetchRedemptionHistoryCount,
        { data: redemptionHistoryCountData, error: redemptionHistoryCountError },
    ] = useFetchRedemptionHistoryCountForTDSMutation();

    const [
        uploadImage,
        {
            data: uploadImageData,
            isLoading: uploadImageIsLoading,
            error: uploadImageError,
        },
    ] = useUploadSingleFileMutation();


    const [
        updateDeliveryDetails,
        {
            data: updateDeliveryDetailsData,
            error: updateDeliveryDetailsError,
            isLoading: updateDeliveryDetailsIsLoading
        },
    ] = useUpdateDeliveryDetailsGiftRedemptionMutation();

    const [
        updateRedeemedGiftsStatus,
        {
            data: updateRedeemedGiftsStatusData,
            error: updateRedeemedGiftsStatusError,
        },
    ] = useUpdateRedeemedGiftsStatusMutation();

    const [
        getExtraRedeemedGiftsStatus,
        {
            data: getExtraRedeemedGiftsStatusData,
            error: getExtraRedeemedGiftsStatusError,
        },
    ] = useGetExtraRedeemedGiftsStatusMutation();

    const [
        deleteRedemptionRequest,
        { data: deleteRedemptionData, error: deleteRedemptionError },
    ] = useDeleteRedemptionMutation();

    const getExtraRedeemGiftStausFunc = (userType) => {

        getExtraRedeemedGiftsStatus({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            user_type: userType,
        });
    }

    useEffect(() => {
        if (getExtraRedeemedGiftsStatusData) {
            console.log("getExtraRedeemedGiftsStatusData data", getExtraRedeemedGiftsStatusData);
            setExtraStatus(getExtraRedeemedGiftsStatusData?.body ? getExtraRedeemedGiftsStatusData?.body : []);

            const redeemStatus = [...getRedeemedGiftsStatusData?.body]
            const newRedeemStatus = [
                ...redeemStatus.slice(0, 2),
                ...getExtraRedeemedGiftsStatusData.body,
                ...redeemStatus.slice(2)
            ];

            // console.log("newRedeemStatus", newRedeemStatus);
            setredeemGiftStatusData(newRedeemStatus);
        }
    }, [getExtraRedeemedGiftsStatusData]);

    useEffect(() => {
        if (getRedeemedGiftsStatusData && getRedeemedGiftsStatusData?.body) {
            setredeemGiftStatusData(getRedeemedGiftsStatusData?.body ? getRedeemedGiftsStatusData?.body : []);
        }

        if (getRedeemedGiftsStatusError) {
            console.error("getRedeemedGiftsStatusError", getRedeemedGiftsStatusError);
        }
    }, [getRedeemedGiftsStatusData, getRedeemedGiftsStatusError])


    // console.log("redeemGiftStatusData", redeemGiftStatusData);


    useEffect(() => {
        toast.dismiss();
        if (uploadImageData) {
            console.log("success image upload", uploadImageData.body.fileLink);
            setImages(uploadImageData.body.fileLink);
        }
        if (uploadImageError) {
            toast.error("Image upload failed");
        }

        if (uploadImageIsLoading) {
            toast.loading("Uploading your image...", { id: "uploadImageLoading" });
        }
    }, [uploadImageData, uploadImageError, uploadImageIsLoading]);


    const handleFetchRedemptionHistoryCsv = () => {
        const modifiedRequest = {
            ...request,
            limit: null,
            offset: null,
        };
        fetchRedemptionHistoryCsv({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            body: modifiedRequest,
            zoneId: userZone.id,
        });
    };

    const handleFetchRedemptionHistory = () => {
        fetchRedemptionHistory({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            body: request,
            zoneId: userZone.id,
        });
        fetchRedemptionHistoryCount({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
            body: request,
            zoneId: userZone.id,
        });
    };

    const handleFetchRedemptionCountHistory = () => {
        fetchRedemptionHistoryCount({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            body: request,
            zoneId: userZone.id,
        });
    };
    // useEffect(() => {
    //     const hasViewPermission = hasPermission("tdsCalculationOnRedemptions");
    //     if (!hasViewPermission) {
    //         navigate(`/genefied/${getVendorName()}/`);
    //     }
    //     handleFetchRedemptionCountHistory();
    // }, []);

    useEffect(() => {
        if (redemptionHistoryCsvData && redemptionHistoryCsvData?.body?.data) {
            // console.log("csvData", redemptionHistoryCsvData?.body?.data);
            // setCsvData(redemptionHistoryCsvData?.body?.data);
            // setCsvData(transformToJSON(redemptionHistoryCsvData?.body?.data, csvColumns));
            setCsvData(redemptionHistoryCsvData?.body?.data)
        }

        if (redemptionHistoryCsvError) {
            toast.error("Something went wrong", { id: "redemptionHistoryCsvError" })
            setCsvData(null);
        }
    }, [redemptionHistoryCsvData, redemptionHistoryCsvError]);


    useEffect(() => {
        handleFetchRedemptionHistory();
    }, [limit, offset]);

    useEffect(() => {
        if (redemptionHistoryData) {
            // console.log("redemption history", redemptionHistoryData);
            setMyList(
                redemptionHistoryData.body && redemptionHistoryData.body.data
                    ? redemptionHistoryData.body.data
                    : []
            );
        }

        if (redemptionHistoryError) {
            console.log("redemtion error", redemptionHistoryError);
        }
    }, [redemptionHistoryData, redemptionHistoryError]);

    useEffect(() => {
        if (redemptionHistoryCountData) {
            console.log("redemptionHistoryCountData", redemptionHistoryCountData);
            setTotalRows(
                redemptionHistoryCountData.body && redemptionHistoryCountData.body.total
                    ? redemptionHistoryCountData.body.total
                    : 0
            );
        }

        if (redemptionHistoryCountError) {
            console.log("redemptionHistoryCountError", redemptionHistoryCountError);
        }
    }, [redemptionHistoryCountData, redemptionHistoryCountError]);



    const isVoucherCategory = currentGiftCategory?.toLowerCase() === "vouchers";
    const deliveredStatusIndex = getRedeemedGiftsStatusData?.body ? getRedeemedGiftsStatusData.body.length - 1 : null;

    const handleUpdateRedeemedGiftsStatus = () => {
        console.log("selectStatus", selectStatus);
        console.log("lastStatus", lastStatus);

        let remarks = null;

        if (lastStatus == 0) {
            toast.error("This request has already been rejected. You cannot change the status.", { id: "rejected-status" });
            return;
        }

        if (isVoucherCategory && lastStatus == deliveredStatusIndex) {
            toast.error("This order has already been delivered. You cannot change the status.", { id: "delivered-status" });
            return;
        }

        if (isVoucherCategory && selectStatus == deliveredStatusIndex && lastStatus != 2) {
            toast.error("Status must be Approved before marking as Delivered.", { id: "voucher-approve-first" });
            return;
        }

        if (selectStatus == lastStatus) {
            toast.error("you can not update same");
            return;
        }

        //This is for redemption herirarchy
        if (lastStatus == 1 && selectStatus <= 10 && selectStatus > 2) {
            toast.error("You need to change the status to approved first.", { id: "approved-status-required" });
            return;
        }


        if (lastStatus == 2 && selectStatus < 2) {
            toast.error("Status can't be updated", { id: "status-not-updated" });
            return;
        }

        if (selectStatus == 0) {
            remarks = window.prompt("Please add remarks");

            if (!remarks || remarks?.length < 1) {
                toast.error("Please add a remark");
                return;
            }
        }

        // For voucher category, require coupon code on delivery
        if (isVoucherCategory && selectStatus == deliveredStatusIndex) {
            if (!couponCode || couponCode.trim().length < 1) {
                toast.error("Please enter a coupon code");
                return;
            }
            remarks = couponCode.trim();
        }

        updateRedeemedGiftsStatus({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            body: {
                status: selectStatus,
                ref_no: currentRefNo,
                status_change_at: "2",
                ...(remarks
                    ? {
                          remarks: remarks,
                      }
                    : {}),
            },
        });
    };
    useEffect(() => {
        if (updateRedeemedGiftsStatusData) {
            toast.dismiss();
            toast.success(`${updateRedeemedGiftsStatusData.message}`, {
                id: `updateRedeemedGiftsStatusData`,
            });
            handleFetchRedemptionHistory(limit, offset);
            setPopUpBtnToggle(false);
            setCouponCode("");
            setCurrentGiftCategory(null);
        }

        if (updateRedeemedGiftsStatusError) {
            toast.dismiss();
            toast.error(`${updateRedeemedGiftsStatusError.data.message}`, {
                id: `updateRedeemedGiftsStatusError`,
            });
            setPopUpBtnToggle(false);
            setCouponCode("");
            setCurrentGiftCategory(null);
        }
    }, [updateRedeemedGiftsStatusData, updateRedeemedGiftsStatusError]);

    // console.log("getRedeemedGiftsStatusData ----> ", getRedeemedGiftsStatusData);

    useEffect(() => {
        if (updateDeliveryDetailsData && updateDeliveryDetailsData?.body) {
            toast.dismiss();
            toast.success("Delivery Details Updated.", { id: "updateDeliveryDetailsData" })
            handleFetchRedemptionHistory(limit, offset);
            setShowViewModal(false);
            setViewModalData(null);
            setUpdatedDeliveryPartner(null);
            setUpdatedTrackingId(null);

        }

        if (updateDeliveryDetailsError) {
            toast.dismiss();
            toast.error("Something went wrong", { id: "updateDeliveryDetailsError" })
            console.error("updateDeliveryDetailsError", updateDeliveryDetailsError);
        }

        if (updateDeliveryDetailsIsLoading) {
            toast.loading("Please wait..", { id: "updateDeliveryDetailsIsLoading" })
        }
    }, [updateDeliveryDetailsData, updateDeliveryDetailsError, updateDeliveryDetailsIsLoading])


    useMemo(() => {
        for (let index = 0; index < appUsers.length; index++) {
            const element = appUsers[index];
            if (
                element.user_type.toLocaleLowerCase() ===
                userTypesArray?.name?.toLocaleLowerCase()
            ) {
                setUserTypeId(element.user_type_id);
                setRequest((prevRequest) => ({
                    ...prevRequest,
                    user_type_id: +element.user_type_id,
                }));
                break;
            }
        }
    }, [userTypesArray]);

    const handleDeleteRedemption = async (row = {}) => {
        const { ref_no, app_user_id } = row || {};

        const first_check = window.confirm(
            "Are you sure? This is a permnant override action!"
        );

        if (!first_check) {
            return;
        }

        const remark = window.prompt("Please add a remark");

        if (!remark) {
            return toast.error("No remark provided!");
        }

        if (!ref_no || !app_user_id) {
            return toast.error("Invalid Redemption");
        }

        const response = await deleteRedemptionRequest({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
            body: {
                ref_no: ref_no,
                app_user_id: app_user_id,
                remark: remark,
            },
        });

        if (response?.data?.success) {
            toast.success(response?.data?.message || "Redemption deleted!");
            handleFetchRedemptionHistory();
        } else {
            toast.error("Internal server error. Check console for logs.");
            console.log(
                `Redemption ERROR:: ${ref_no} - ${app_user_id}\n`,
                response
            );
        }
    };

    const columns = [
        {
            name: "SNo",
            cell: (row, idx) => offset + Number(idx + 1),
            sortable: true,
            width: "70px",
        },
        {
            name: "Name",
            cell: (row) => row.name,
            sortable: true,
            width: "200px",
        },
        {
            name: "Mobile",
            cell: (row) => row.mobile,
            sortable: true,
            width: "120px",
        },
        {
            name: "User Id",
            cell: (row) => row.userId,
            sortable: true,
            width: "115px",
        },
        {
            name: "Usertype",
            cell: (row) => row.user_type,
            sortable: true,
            width: "115px",
        },
        ...JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == TenantSlugs.siyaram ?
            [
                {
                    name: "Firm Name",
                    cell: (row) => row.firm_name,
                }
            ] : [],
        {
            name: "Redeemed Points",
            cell: (row) => row.redeemed_points,
            sortable: true,
            width: "150px",
        },
        // {
        //   name: "Platform",
        //   cell: (row) => row.platform,
        //   sortable: true,
        //   width: "120px",
        // },
        {
            name: "Type",
            cell: (row) => (redemptionsType[row.redemption_type]),
            sortable: true,
            width: "100px",

        },

        {
            name: "Ref No",
            cell: (row) => row.ref_no,
            sortable: true,
        },
        {
            name: "",
            cell: (row) =>
                <div>
                    <button
                        onClick={() => {
                            setViewModalData(row);
                            setCurrentUserType(row.user_type);
                            getExtraRedeemGiftStausFunc(row.user_type)
                            setCurrentStatus(Number(row.status));
                            setProgressBtnToggle(true);
                            setShowViewModal(true);
                        }}
                        className="flex justify-center items-center rounded bg-blue-800 px-2.5 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-blue-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-blue-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-blue-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
                    >
                        Details
                    </button>
                </div>,

            sortable: true,
            width: "100px",

        },
        // {
        //     name: "Status",
        //     cell: (row) =>
        //         <p>
        //             <span
        //                 className={`px-2 py-1.5 rounded text-white text-xs font-semibold ${approvalStatusTypes[row?.approval_status]?.color || 'bg-gray-400'
        //                     }`}
        //             >
        //                 {approvalStatusTypes[row?.approval_status]?.label || 'UNKNOWN'}
        //             </span>
        //         </p>,

        //     sortable: true,
        // },
        {
            name: "Status",
            cell: (row) =>
                row.redemption_type == "1" ? (
                    <button
                        className={`lex justify-center items-center rounded px-2.5 pb-1.5 pt-1.5  uppercase leading-normal shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out  text-white text-xs font-semibold ${row.status === '0'
                            ? 'bg-red-600'
                            : row.status >= 2 && row.status <= 10
                                ? 'bg-green-600'
                                : 'bg-gray-500'
                            }`}

                        onClick={() => {

                            setCurrentRefNo(row.ref_no);
                            setSelectStatus(Number(row.status));
                            setCurrentUserType(row.user_type);
                            getExtraRedeemGiftStausFunc(row.user_type)
                            setLastStatus(Number(row.status))
                            setCurrentGiftCategory(row.gift?.gift?.[0]?.category || null);
                            setCouponCode("");
                            setViewModalData(row);

                            if (Number(row.status) == 0) {
                                toast.error("This request has aleady been rejected. you cannot change the status.", { id: "rejected-status" });
                                return;
                            }

                            setPopUpBtnToggle(true);
                        }
                        }
                    >
                        {Number(row.status) <= 10 ? (getRedeemedGiftsStatusData?.body && getRedeemedGiftsStatusData.body[Number(row.status)])
                            : (redemptionHierarchy && redemptionHierarchy[row.user_type][Number(row.status) - 11])}

                    </button>
                ) : (
                    <button className={`px-2 py-1.5 rounded text-white text-xs font-semibold ${row.status === '0'
                        ? 'bg-red-600'
                        : row.status >= 2 && row.status <= 10
                            ? 'bg-green-600'
                            : 'bg-gray-500'
                        }`}>
                        {getRedeemedGiftsStatusData?.body &&
                            getRedeemedGiftsStatusData.body[Number(row.status)]}
                    </button>
                ),

            sortable: true,
        },
        {
            name: "Date",
            cell: (row) => row.redemption_date ? new Date(row.redemption_date).toLocaleString() : "",
            sortable: true,
        },
        ...(isRejectEnabled
            ? [
                  {
                      name: "Action",
                      cell: (row) => (
                          <button
                              className="px-2 py-1.5 bg-red-600 text-white rounded hover:bg-red-700 uppercase text-xs transition disabled:saturate-0 disabled:opacity-90"
                              disabled={["10", "0"]?.includes(
                                  row?.status?.toString()
                              )}
                              onClick={() =>
                                  !["10", "0"]?.includes(
                                      row?.status?.toString()
                                  ) && handleDeleteRedemption(row)
                              }
                          >
                              Reject
                          </button>
                      ),
                      sortable: true,
                  },
              ]
            : []),
    ];

    const handlePageChange = (pageNumber) => {
        const newOffset = (pageNumber - 1) * limit;
        setOffset(newOffset);
        setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
        setCurrentPage(pageNumber);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setRequest((prevRequest) => ({
          ...prevRequest,
          limit: newPerPage,
          offset: 0,
        }));
        setLimit(newPerPage);
    setOffset(0);
        setCurrentPage(1);
        setPaginationResetToggle((prev) => !prev);

    };

    const handleUpdateDeliveryDetails = () => {

        if (window.confirm("Are you sure ?")) {
            const requestBody = {
                ref_no: viewModalData.ref_no,
                tracking_id: updatedTrackingId,
                delivery_partner: updatedDeliveryPartner
            }

            if (images) {
                requestBody['image'] = images;
            }

            updateDeliveryDetails({
                token: sessionStorage.getItem("access_token"),
                tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
                body: requestBody,
            });

            setImages()
        }
    };

    const previewImage = (event) => {
        // setFormImg(event.target.files[0]);
        const formData = new FormData();
        formData.append("image", event.target.files[0]);
        uploadImage({
            body: formData,
        });

    };

    return (
        <>
            <div className="flex w-full bg-gray-200 h-full justify-center">
                <div className="w-full ">
                    <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                        Redemptions
                        <LinksComponent />
                    </div>

                    <div className="p-3">

                        <div className="mb-2">
                            <CustomExport
                                fetchData={handleFetchRedemptionHistoryCsv}
                                data={csvData}
                                defaultColumnExport={[
                                    "name",
                                    "email",
                                    "mobile",
                                    "user_type",
                                    "points",
                                    "redemption_type",
                                    "address",
                                    "ref_no",
                                    "gift",
                                    "statusUpdateDetails"
                                ]}
                                formatColumns={["statusUpdateDetails", "gift", "address"]}
                                filename="redeem_request"
                            />
                        </div>
                        <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
                            <div className="flex  space-x-2 ">
                                <div className="w-52">
                                    <div className="relative searchin">
                                        <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                            Name
                                        </label>
                                        <input
                                            type="search"
                                            id="default-search"
                                            className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                            placeholder="Name..."
                                            required
                                            value={request.name}
                                            onChange={(e) => {
                                                const newValue = e.target.value;
                                                setRequest((prevState) => {
                                                    return { ...prevState, name: newValue };
                                                });
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="w-52">
                                    <div className="relative searchin">
                                        <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                            Mobile
                                        </label>
                                        <input
                                            type="search"
                                            id="default-search"
                                            className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                            placeholder="Mobile No..."
                                            required
                                            value={request.mobile}
                                            onChange={(e) => {
                                                const newValue = e.target.value;
                                                setRequest((prevState) => {
                                                    return { ...prevState, mobile: newValue };
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="w-52">
                                    <div className="relative searchin">
                                        <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                            User Id
                                        </label>
                                        <input
                                            type="search"
                                            id="default-search"
                                            className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                            placeholder="User Id..."
                                            required
                                            value={request.user_id}
                                            onChange={(e) => {
                                                const newValue = e.target.value;
                                                setRequest((prevState) => {
                                                    return { ...prevState, user_id: newValue };
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="w-52">
                                    <div className="relative searchin">
                                        <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                            Ref No
                                        </label>
                                        <input
                                            type="search"
                                            id="default-search"
                                            className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                            placeholder="Ref No."
                                            required
                                            value={request.ref_no}
                                            onChange={(e) => {
                                                const newValue = e.target.value;
                                                setRequest((prevState) => {
                                                    return { ...prevState, ref_no: newValue };
                                                });
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="w-52 ">
                                    <div className="flex-col slc_dvd topslt">
                                        <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                            User Types
                                        </label>
                                        <div className="relative searchin">
                                            {appUsers && appUsers.length > 0 && (
                                                <SelectComponent
                                                    className="capitalize"
                                                    //title={"User Types"}
                                                    selected={userTypesArray}
                                                    setSelected={setUserTypesArray}
                                                    dataArr={appUsers}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="w-52">
                                    <div className="relative searchin topslt">
                                        <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                            Zones
                                        </label>
                                        <div className="relative searchin">
                                            <SelectComponent
                                                placeholder={"Select Zone*"}
                                                selected={userZone}
                                                setSelected={setUserZone}
                                                dataArr={allZones}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="w-52 searchin">
                                    <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                        From Date
                                    </label>
                                    <input
                                        type="date"
                                        className="w-full  text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                        placeholder=""
                                        value={request.startDate}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    startDate: newValue,
                                                };
                                            });
                                        }}
                                    />
                                </div>

                                <div className="w-52 searchin">
                                    <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                        End Date
                                    </label>
                                    <input
                                        type="date"
                                        className="w-full  text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                        placeholder=""
                                        value={request.endDate}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    endDate: newValue,
                                                };
                                            });
                                        }}
                                    />
                                </div>

                                <div className="">
                                    <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                        &nbsp;
                                    </label>
                                    <div className="relative searchin gap-2 flex">
                                        <button
                                            className="py-2 btn btn-outline-primary clear-both float-right  pdbtn_all"
                                            onClick={() => {
                                                handleFetchRedemptionHistory();
                                                handleFetchRedemptionCountHistory();
                                            }}
                                        >
                                            Search
                                        </button>

                                        <button
                                            className="btn btn-outline-primary clear-both float-right pdbtn_all whitespace-nowrap"
                                            onClick={() => {
                                                clearFilters();
                                            }}
                                        >
                                            Clear Filter
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="p-3 bg-white shadow rounded-lg">
                            <DataTableComponent
                                keyField={(row) => row.SNo}
                                columns={columns}
                                // title={""}
                                data={myList}
                                // loading={loading}
                                totalRows={totalRows}
                                handlePerRowsChange={handlePerRowsChange}
                                handlePageChange={handlePageChange}
                                paginationDefaultPage={currentPage}
                                paginationResetDefaultPage={paginationResetToggle}
                            ></DataTableComponent>

                            {showViewModal && viewModalData && (
                                <ModalComponent size={"7xl"} show={showViewModal} setShow={setShowViewModal}>
                                    <div className="w-full overflow-y-auto p-2">
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full h-full p-4 overflow-auto">

                                            {/* Left Column - Info */}
                                            <div className="space-y-8">

                                                {/* Redemption Details */}
                                                <section>
                                                    <h3 className="text-lg font-semibold mb-3 border-b pb-1">📄 Redemption Details</h3>

                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2 text-sm mb-4">
                                                        <p><span className="font-medium">Name:</span> {viewModalData?.name}</p>
                                                        <p><span className="font-medium">Mobile:</span> {viewModalData?.mobile}</p>
                                                        <p><span className="font-medium">User Type:</span> {viewModalData?.user_type?.toUpperCase()}</p>
                                                        <p><span className="font-medium">Ref No:</span> {viewModalData?.ref_no}</p>
                                                        <p>
                                                            <span className="font-medium">Status:</span>{' '}
                                                            <span
                                                                className={`px-2 py-1.5 rounded text-white text-xs font-semibold ${approvalStatusTypes[viewModalData?.approval_status]?.color || 'bg-gray-400'
                                                                    }`}
                                                            >
                                                                {approvalStatusTypes[viewModalData?.approval_status]?.label || 'UNKNOWN'}
                                                            </span>
                                                        </p>
                                                    </div>

                                                    <div className="overflow-x-auto">
                                                        <table className="min-w-full text-sm border rounded">
                                                            {["1", "3"].includes(viewModalData?.approval_status) &&
                                                                <>
                                                                    <thead className="bg-gray-100 text-left">
                                                                        <tr>
                                                                            <th className="p-2 border">Label</th>
                                                                            <th className="p-2 border">Value</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>

                                                                    {
                                                                        JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == TenantSlugs.siyaram
                                                                            ?
                                                                            (
                                                                                <>
                                                                                    <tr>
                                                                                        <td className="p-2 border">Balance On Redemption</td>
                                                                                        <td className="p-2 border">{formatter.format(viewModalData?.balance_on_redemption)}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="p-2 border">Redeemed Points</td>
                                                                                        <td className="p-2 text-red-600 border">{formatter.format(viewModalData?.redeemed_points)}</td>
                                                                                    </tr>




                                                                                    {viewModalData?.approval_status === "1" && (
                                                                                        <>
                                                                                            <tr>
                                                                                                <td className="p-2 border">Balance After Redemption</td>
                                                                                                <td className="p-2 border">
                                                                                                    {viewModalData?.balance_after_tds
                                                                                                        ? formatter.format(viewModalData.balance_after_tds)
                                                                                                        : formatter.format(viewModalData.balance_on_redemption - viewModalData.redeemed_points)}
                                                                                                </td>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td className="p-2 border">Redemption Type</td>
                                                                                                <td className="p-2 border">{redemptionsType[viewModalData?.redemption_type]}</td>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td className="p-2 border">Time</td>
                                                                                                <td className="p-2 border">
                                                                                                    {viewModalData?.tds_deducted_at
                                                                                                        ? new Date(viewModalData.tds_deducted_at).toLocaleString()
                                                                                                        : "—"}
                                                                                                </td>
                                                                                            </tr>
                                                                                        </>
                                                                                    )}
                                                                                </>
                                                                            )
                                                                            :
                                                                            (
                                                                                <>
                                                                                    <tr>
                                                                                        <td className="p-2 border">Balance On Redemption</td>
                                                                                        <td className="p-2 border">{formatter.format(viewModalData?.balance_on_redemption)}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="p-2 border">Redeemed Points</td>
                                                                                        <td className="p-2 text-red-600 border">{formatter.format(viewModalData?.redeemed_points)}</td>
                                                                                    </tr>




                                                                                    {viewModalData?.approval_status === "1" && (
                                                                                        <>
                                                                                            <tr>
                                                                                                <td className="p-2 border">Balance Before TDS</td>
                                                                                                <td className="p-2 border">{viewModalData?.balance_before_tds ? formatter.format(viewModalData?.balance_before_tds) : "N/A"}</td>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td className="p-2 border">Taxed Amount</td>
                                                                                                <td className="p-2 border">{viewModalData?.taxed_amount ? formatter.format(viewModalData?.taxed_amount) : "N/A"}</td>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td className="p-2 border">TDS Amount</td>
                                                                                                <td className="p-2 border text-red-600">{viewModalData?.tds_amount ? formatter.format(viewModalData?.tds_amount) : "N/A"}</td>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td className="p-2 border">Balance After TDS</td>
                                                                                                <td className="p-2 border">
                                                                                                    {viewModalData?.balance_after_tds
                                                                                                        ? formatter.format(viewModalData.balance_after_tds)
                                                                                                        : formatter.format(viewModalData.balance_on_redemption - viewModalData.redeemed_points)}
                                                                                                </td>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td className="p-2 border">Redemption Type</td>
                                                                                                <td className="p-2 border">{redemptionsType[viewModalData?.redemption_type]}</td>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td className="p-2 border">TDS Deducted At</td>
                                                                                                <td className="p-2 border">
                                                                                                    {viewModalData?.tds_deducted_at
                                                                                                        ? new Date(viewModalData.tds_deducted_at).toLocaleString()
                                                                                                        : "—"}
                                                                                                </td>
                                                                                            </tr>
                                                                                        </>
                                                                                    )}
                                                                                </>
                                                                            )
                                                                    }
                                                                    </tbody>
                                                                </>

                                                            }
                                                        </table>
                                                    </div>
                                                </section>

                                                {/* Gift Details */}
                                                <section>
                                                    <h3 className="text-lg font-semibold mb-3 border-b pb-1">🎁 Gift Details</h3>
                                                    <div className="flex flex-col md:flex-row gap-4 text-sm">
                                                        {viewModalData?.gift?.gift?.[0]?.images?.[0] && (
                                                            <img
                                                                src={viewModalData.gift.gift[0].images[0]}
                                                                alt={viewModalData.gift.gift[0].name}
                                                                className="w-20 h-20 object-contain border rounded"
                                                            />
                                                        )}
                                                        <div>
                                                            <p><span className="font-medium">Name:</span> {viewModalData.gift.gift[0]?.name}</p>
                                                            <p><span className="font-medium">Brand:</span> {viewModalData.gift.gift[0]?.brand}</p>
                                                            <p><span className="font-medium">Category:</span> {viewModalData.gift.gift[0]?.category}</p>
                                                            <p><span className="font-medium">Points:</span> {viewModalData.gift.gift[0]?.points}</p>
                                                            <p><span className="font-medium">Value:</span> ₹{viewModalData.gift.gift[0]?.value}</p>
                                                        </div>
                                                    </div>
                                                    {/* Show coupon code for voucher category when delivered */}
                                                    {viewModalData.gift?.gift?.[0]?.category?.toLowerCase() === "vouchers" && Number(viewModalData?.status) == (getRedeemedGiftsStatusData?.body ? getRedeemedGiftsStatusData.body.length - 1 : -1) && viewModalData?.remarks && (
                                                        <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg">
                                                            <p className="text-sm font-medium text-green-800 mb-1">🎟️ Coupon Code</p>
                                                            <p className="font-mono text-base tracking-wide text-green-900">{viewModalData?.remarks || "N/A"}</p>
                                                        </div>
                                                    )}
                                                </section>

                                                {/* Address Details */}
                                                <section>
                                                    <h3 className="text-lg font-semibold mb-3 border-b pb-1">📍 Address Details</h3>
                                                    <div className="text-sm leading-relaxed">
                                                        <p><span className="font-medium">Address:</span> {viewModalData.address?.address}</p>
                                                        <p><span className="font-medium">City:</span> {viewModalData.address?.city}</p>
                                                        <p><span className="font-medium">District:</span> {viewModalData.address?.district}</p>
                                                        <p><span className="font-medium">State:</span> {viewModalData.address?.state}</p>
                                                        <p><span className="font-medium">Country:</span> {viewModalData.address?.country}</p>
                                                        <p><span className="font-medium">Pincode:</span> {viewModalData.address?.pincode}</p>
                                                    </div>
                                                </section>
                                            </div>

                                            {/* Right Column - Delivery Progress */}
                                            <div className="border-l pl-2 text-sm">
                                                <h3 className="text-lg font-semibold mb-3 border-b pb-1">🚚 Delivery Progress</h3>
                                                <div className="text-gray-500 italic">Tracking info or progress steps will be shown here.</div>
                                                    

                                                {
                                                    Number(viewModalData?.status) != 0 &&

                                                    <section>
                                                        <div className="w-full p-2">
                                                            <div className="flex justify-start">
                                                                <div className="container px-1">
                                                                    <DeliveryProgressBar
                                                                        totalStatuses={
                                                                            viewModalData.gift?.gift?.[0]?.category?.toLowerCase() === "vouchers"
                                                                                ? (() => {
                                                                                    const base = redeemGiftStatusData.slice(0, 3 + extraStatus.length + 1);
                                                                                    const deliveredName = getRedeemedGiftsStatusData?.body?.[getRedeemedGiftsStatusData.body.length - 1];
                                                                                    if (deliveredName && !base.includes(deliveredName)) {
                                                                                        return [...base, deliveredName];
                                                                                    }
                                                                                    return base;
                                                                                })()
                                                                                : redeemGiftStatusData
                                                                        }
                                                                        completedStatuses={viewModalData.statusUpdateDetails}
                                                                        type={1}
                                                                        showReject={viewModalData.gift?.gift?.[0]?.category?.toLowerCase() === "vouchers"}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {/* Show coupon code for voucher when delivered */}
                                                            {viewModalData.gift?.gift?.[0]?.category?.toLowerCase() === "vouchers" && Number(viewModalData?.status) == (getRedeemedGiftsStatusData?.body ? getRedeemedGiftsStatusData.body.length - 1 : -1) && viewModalData?.remarks && (
                                                                <div className="mt-4 p-3 bg-green-50 border border-green-200 rounded-lg">
                                                                    <p className="text-sm font-medium text-green-800 mb-1">🎟️ Coupon Code</p>
                                                                    <p className="font-mono text-base tracking-wide text-green-900">{viewModalData?.remarks || "N/A"}</p>
                                                                </div>
                                                            )}

                                                                {/* <ol class="relative text-gray-500 border-l border-gray-200 dark:border-gray-700 dark:text-gray-400">
                                                                    {redeemGiftStatusData.map((x, index) => {
                                                                        if (index == 0) {
                                                                            return <></>;
                                                                        }
                                                                        if (index <= currentStatus) {
                                                                            return (
                                                                                <li class="mb-4 ml-7 flex items-center">
                                                                                    <span class="absolute flex items-center justify-center w-8 h-8 bg-green-200 rounded-full -left-4 ring-4 ring-white dark:ring-gray-900 dark:bg-green-900">
                                                                                        <svg
                                                                                            class="w-3.5 h-3.5 text-green-500 dark:text-green-400"
                                                                                            aria-hidden="true"
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                            fill="none"
                                                                                            viewBox="0 0 16 12"
                                                                                        >
                                                                                            <path
                                                                                                stroke="currentColor"
                                                                                                strokeLinecap="round"
                                                                                                strokeLinejoin="round"
                                                                                                strokeWidth="2"
                                                                                                d="M1 5.917 5.724 10.5 15 1.5"
                                                                                            />
                                                                                        </svg>
                                                                                    </span>

                                                                                    {JSON.stringify(redeemGiftStatusData)}
                                                                                    {JSON.stringify(viewModalData.statusUpdateDetails)}
                                                                                    <h3 class="font-medium leading-tight capitalize fntchng">
                                                                                        {x}
                                                                                        {viewModalData.statusUpdateDetails &&
                                                                                            viewModalData.statusUpdateDetails.length > 0 &&
                                                                                            viewModalData.statusUpdateDetails
                                                                                                .filter((y) => +y.status === index)
                                                                                                .map((filteredRow) => (
                                                                                                    <span key={filteredRow.id}>
                                                                                                        {filteredRow?.created_name} <br />
                                                                                                        {new Date(
                                                                                                            filteredRow.created_at
                                                                                                        ).toLocaleString()}
                                                                                                    </span>
                                                                                                ))}
                                                                                    </h3>
                                                                                </li>
                                                                            );
                                                                        }
                                                                        else {
                                                                            return (
                                                                                <li class="mb-10 ml-7 flex items-center">
                                                                                    <span class="absolute flex items-center justify-center w-8 h-8 bg-gray-100 rounded-full -left-4 ring-4 ring-white dark:ring-gray-900 dark:bg-gray-700">
                                                                                        <svg
                                                                                            class="w-3.5 h-3.5 text-gray-500 dark:text-gray-400"
                                                                                            aria-hidden="true"
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                            fill="currentColor"
                                                                                            viewBox="0 0 20 16"
                                                                                        >
                                                                                            <path d="M18 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2ZM6.5 3a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3.014 13.021l.157-.625A3.427 3.427 0 0 1 6.5 9.571a3.426 3.426 0 0 1 3.322 2.805l.159.622-6.967.023ZM16 12h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2Zm0-3h-3a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2Zm0-3h-3a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2Z" />
                                                                                        </svg>
                                                                                    </span>
                                                                                    <h3 class="font-medium leading-tight capitalize">
                                                                                        {x}
                                                                                    </h3>

                                                                                </li>
                                                                            );
                                                                        }
                                                                    })}


                                                                </ol> */}
                                                        </div>
                                                    </section>
                                                }
                                            </div>

                                            <div className="border-l pl-4 text-sm">
                                                <h3 className="text-lg font-semibold mb-3 border-b pb-1">🚚 Delivery Address Details</h3>
                                                <div className="text-gray-500 italic">Tracking info will be shown here.</div>

                                                {Number(viewModalData?.status) >= 7 && Number(viewModalData?.status) <= 10 && (
                                                    <section className="bg-gray-50 p-4 rounded-md shadow-sm space-y-4">
                                                        {viewModalData.delivery_details ? (
                                                            <div className="space-y-2">
                                                                <h4 className="text-base font-semibold text-gray-700">Current Delivery Details</h4>
                                                                <div className="text-sm text-gray-800 space-y-1">
                                                                    <p><strong>Partner:</strong> {viewModalData.delivery_details?.delivery_partner || "N/A"}</p>
                                                                    <p><strong>Tracking ID:</strong> {viewModalData.delivery_details?.tracking_id || "N/A"}</p>
                                                                </div>
                                                                {viewModalData?.delivery_details?.image && (
                                                                    <span className="w-100 h-100 d-block m-auto border rounded-md p-3">
                                                                        <img
                                                                            src={viewModalData?.delivery_details?.image}
                                                                            alt="delivery-img"
                                                                            className="img-fluid flex items-center justify-center w-48 m-auto "
                                                                        />
                                                                    </span>
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <p className="text-gray-500 italic">No delivery details available.</p>
                                                        )}

                                                        {/* Update Delivery Details Form */}
                                                        <div className="grid gap-4 mt-4">
                                                            <div>
                                                                <label className="block text-sm font-medium text-gray-700 mb-1">Update Delivery Partner</label>
                                                                <select
                                                                    className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm"
                                                                    value={updatedDeliveryPartner}
                                                                    onChange={(e) => setUpdatedDeliveryPartner(e.target.value)}
                                                                >
                                                                    <option value="">Select Delivery Partner</option>
                                                                    {[
                                                                        "Delhivery", "Shiprocket", "Mark express", "Trackon", "Skyking",
                                                                        "Anjani couerier", "safe express", "Amazon shipping", "Ecom Express",
                                                                        "DTDC", "EKART", "SHADOW FAX SURFACE", "Xpress bees", "Clickpost",
                                                                        "Bluedart", "FedEx", "Gati", "Amazon", "Flipkart"
                                                                    ].map((partner) => (
                                                                        <option key={partner} value={partner}>
                                                                            {partner}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            <div>
                                                                <label className="block text-sm font-medium text-gray-700 mb-1">Tracking ID</label>
                                                                <input
                                                                    type="text"
                                                                    className="w-full border-gray-300 rounded-md shadow-sm px-3 py-2 text-sm focus:ring-blue-500 focus:border-blue-500"
                                                                    value={updatedTrackingId}
                                                                    onChange={(e) => setUpdatedTrackingId(e.target.value)}
                                                                    placeholder="Enter Tracking ID"
                                                                />
                                                            </div>

                                                            <div className="w-full flex justify-center ">
                                                                <div className="flex items-center justify-center w-full">
                                                                    <label
                                                                        for="dropzone-file"
                                                                        className="flex flex-col items-center justify-center w-full h-44 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50   hover:bg-gray-100  "
                                                                    >
                                                                        <div className="flex flex-col items-center justify-center">
                                                                            <svg
                                                                                aria-hidden="true"
                                                                                className="w-20 h-20 mb-3 text-gray-400"
                                                                                fill="none"
                                                                                stroke="currentColor"
                                                                                viewBox="0 0 24 24"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                            >
                                                                                <path
                                                                                    stroke-linecap="round"
                                                                                    strokeLinejoin="round"
                                                                                    stroke-width="2"
                                                                                    d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                                                                                ></path>
                                                                            </svg>
                                                                            <p className="mb-2 text-sm text-gray-500">
                                                                                <span className="font-semibold">Click to upload</span>{" "}
                                                                                or drag and drop
                                                                            </p>
                                                                            <p className="text-xs text-gray-500">
                                                                                PNG or JPG
                                                                            </p>
                                                                        </div>
                                                                        <input
                                                                            id="dropzone-file"
                                                                            type="file"
                                                                            accept="image/*"
                                                                            className="hidden"
                                                                            onChange={(e) => previewImage(e)}
                                                                        />
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            {images && (
                                                                <span className="w-100 h-100 d-block m-auto border rounded-md p-3">
                                                                    <img
                                                                        src={images}
                                                                        alt="delivery-img"
                                                                        className="img-fluid flex items-center justify-center w-48 m-auto "
                                                                    />
                                                                </span>
                                                            )}

                                                            <button
                                                                onClick={handleUpdateDeliveryDetails}
                                                                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 rounded-md transition"
                                                            >
                                                                Update Delivery Details
                                                            </button>
                                                        </div>
                                                    </section>
                                                )}

                                                

                                            </div>
                                        </div>

                                    </div>

                                </ModalComponent>
                            )}

                            {popUpBtnToggle && (
                                <ModalComponent
                                    size={"md"}
                                    show={popUpBtnToggle}
                                    setShow={setPopUpBtnToggle}
                                >
                                    <div className="w-full p-4">
                                        {/* If voucher is already delivered, show coupon code as read-only */}
                                        {isVoucherCategory && lastStatus == deliveredStatusIndex ? (
                                            <div className="w-full">
                                                <div className="text-center mb-3">
                                                    <span className="inline-block px-3 py-1 bg-green-100 text-green-800 text-sm font-semibold rounded-full">
                                                        ✅ Delivered
                                                    </span>
                                                </div>
                                                {viewModalData?.remarks && (
                                                    <>
                                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                                            Coupon Code
                                                        </label>
                                                        <div className="shadow-sm bg-gray-100 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 font-mono tracking-wide">
                                                            {viewModalData?.remarks}
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        ) : (
                                            <>
                                                <div className="w-full flex justify-center ">
                                                    <select
                                                        type="text"
                                                        className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 h-auto capitalize"
                                                        value={selectStatus}
                                                        onChange={(e) =>
                                                            setSelectStatus(Number(e.target.value))
                                                        }
                                                    >
                                                        <option key={0} value={Number(0)}>
                                                            {"Reject"}
                                                        </option>
                                                        <option key={1} value={Number(1)}>
                                                            {"Pending"}
                                                        </option>
                                                        {getExtraRedeemedGiftsStatusData &&
                                                            getExtraRedeemedGiftsStatusData.body.map(
                                                                (x, index) => {
                                                                    return (
                                                                        <option
                                                                            key={11 + index}
                                                                            value={Number(11 + index)}
                                                                        >
                                                                            {x}_approval
                                                                        </option>
                                                                    );
                                                                }
                                                            )}
                                                        {getRedeemedGiftsStatusData &&
                                                            getRedeemedGiftsStatusData.body.map((x, index) => {
                                                                if (index == 0 || index == 1) {
                                                                    return <></>;
                                                                }
                                                                // For voucher category, only show Approved (index 2) and Delivered (last index)
                                                                if (isVoucherCategory && index > 2 && index !== deliveredStatusIndex) {
                                                                    return <></>;
                                                                }
                                                                return (
                                                                    <option key={index} value={Number(index)}>
                                                                        {x}
                                                                    </option>
                                                                );
                                                            })}
                                                    </select>
                                                </div>
                                                {/* Show coupon code input for voucher category when marking as delivered */}
                                                {isVoucherCategory && selectStatus == deliveredStatusIndex && lastStatus != deliveredStatusIndex && (
                                                    <div className="w-full mt-3">
                                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                                            Coupon Code <span className="text-red-500">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                                            placeholder="Enter coupon code..."
                                                            value={couponCode}
                                                            onChange={(e) => setCouponCode(e.target.value)}
                                                        />
                                                    </div>
                                                )}
                                                {/* Show existing coupon code when voucher is already delivered */}
                                                {isVoucherCategory && lastStatus == deliveredStatusIndex && viewModalData?.remarks && (
                                                    <div className="w-full mt-3 p-3 bg-green-50 border border-green-200 rounded-lg">
                                                        <p className="text-sm font-medium text-green-800 mb-1">🎟️ Coupon Code</p>
                                                        <p className="font-mono text-base tracking-wide text-green-900">{viewModalData?.remarks}</p>
                                                    </div>
                                                )}
                                                <div className="w-full flex justify-center mt-4 ">
                                                    <button
                                                        className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                                                        onClick={handleUpdateRedeemedGiftsStatus}
                                                    >
                                                        Submit
                                                    </button>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </ModalComponent>
                            )}


                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RedemptionsList;

const csvColumns = [
    { header: "Id", field: "id" },
    { header: "Reference Number", field: "ref_no" },
    { header: "App User ID", field: "app_user_id" },
    { header: "User Type", field: "user_type" },
    { header: "User ID", field: "userId" },
    { header: "Redeemed Points", field: "redeemed_points" },
    { header: "User Name", field: "name" },
    { header: "Email", field: "email" },
    { header: "Mobile", field: "mobile" },
    { header: "Gift Name", field: "gift.gift[0].name" },
    { header: "Gift Brand", field: "gift.gift[0].brand" },
    { header: "Gift Value", field: "gift.gift[0].value" },
    { header: "Address", field: "address.address" },
    { header: "City", field: "address.city" },
    { header: "Pincode", field: "address.pincode" },
    { header: "District", field: "address.district" },
    { header: "State", field: "address.state" },
    { header: "Current Status", field: "statusUpdateDetails[length-1].status_name" },
    { header: "Status Change Date", field: "statusUpdateDetails[length-1].created_at" },
    { header: "Created At", field: "redemption_date" },
    { header: "Balance On Redemption", field: "balance_on_redemption" },
    { header: "Balance Before Tds", field: "balance_before_tds" },
    { header: "Taxed Amount", field: "taxed_amount" },
    { header: "Redeemed Points Till Now", field: "redeemed_points_till_now" },
    { header: "Balance After Tds", field: "balance_after_tds" },
    { header: "Status Update Details", field: "statusUpdateDetails"}

];
